import { Modal } from "react-bootstrap";
import Spinner from "../Components/Spinner";
import { useLanguage } from "../Translations/LenguageContext";

const UnsavedChangesModal = ({ show, handleClose, handleSave, loadingSave, handleContinueWithoutSaving }) => {
    const {t} = useLanguage()
    
    const handleSaveChanges = () => {
        handleSave()
        setTimeout(() => {
            handleClose()
        }, 1500);
    }

    return (
        <Modal show={show} onHide={handleClose} size="sm" centered className="mcp_modal_custom">
            <div className="logout_modal_body">
                <p className="logout_modal_body_title">{t.abilities.unsaved_title}</p>
            </div>

            <div className="modal_footer_logout">
                <button className="modale_close_btn" onClick={handleContinueWithoutSaving}>
                    {t.abilities.continue_unsaved}
                </button>
                <button
                    className="modale_save_btn"
                    onClick={handleSaveChanges}
                >
                    {loadingSave ? <Spinner loading={true} /> : t.save}
                </button>
            </div>
        </Modal>
    );
};

export default UnsavedChangesModal;